export default "__VITE_ASSET__BUkU5TXQ__"